import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import { CompletedWorkout } from "features/Workouts/Workouts.types";
import * as Components from "./AthleteProfileActivityFeedCompleteWorkouts.components";
import ChevronRight from "@mui/icons-material/ChevronRight";
import IconButton from "components/IconButton";
import LinkUtilityComponent from "components/mui5/components/LinkUtilityComponent";
import Mui5 from "components/mui5";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";

interface AthleteProfileActivityFeedCompleteWorkoutsProps {
  completedWorkouts: CompletedWorkout[];
}

function AthleteProfileActivityFeedCompleteWorkouts(props: AthleteProfileActivityFeedCompleteWorkoutsProps) {
  const { completedWorkouts } = props;
  const { t } = useTranslation();

  if (!completedWorkouts.length) return null;

  return (
    <Box>
      <Box sx={{ pt: 1, pb: 2 }}>
        <Typography variant="h3">
          <Box component="span" sx={{ fontWeight: "fontWeightBold" }}>
            {t("athlete_profile_activity_feed_complete_workouts.title")}
          </Box>
        </Typography>
      </Box>
      <Grid container>
        {completedWorkouts.map((completedWorkout) => (
          <Grid size={12} key={completedWorkout.id} pb={1}>
            <Mui5.Paper
              component={(props) => (
                <Components.CompletedWorkoutButtonBase
                  {...props}
                  LinkComponent={LinkUtilityComponent}
                  href={`/workouts/${completedWorkout.source.templateId}/completed/${completedWorkout.id}`}
                />
              )}
            >
              <Box
                sx={{
                  p: 2,
                  pt: 1.6,
                  pb: 1.6,
                  position: "relative",
                  width: "100%",
                }}
              >
                <Grid container alignItems="center" justifyContent="space-between">
                  <Grid size="grow">
                    <Typography variant="h4" noWrap title={completedWorkout.workoutName}>
                      {completedWorkout.workoutName}
                    </Typography>
                  </Grid>
                  <Grid>
                    <ThemeProvider2024>
                      <IconButton
                        size="small"
                        color="primary"
                        aria-hidden
                        tabIndex={-1}
                        component="span"
                        title={t("global.view_completed_workout_label")}
                        aria-label={t("global.view_completed_workout_label")}
                      >
                        <ChevronRight />
                      </IconButton>
                    </ThemeProvider2024>
                  </Grid>
                </Grid>
              </Box>
            </Mui5.Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default AthleteProfileActivityFeedCompleteWorkouts;
